// extracted by mini-css-extract-plugin
export default {"Slides__container":"Slides_Slides__container__mTfO1","Slides__figure":"Slides_Slides__figure__Nst0Q","Slides__image":"Slides_Slides__image__01EiQ"};